import { OnboardingFileQuery } from './OnboardingFile.query';

const OnboardingFile = () => {
  return <OnboardingFileQuery />;
};

export { OnboardingFile };
